// mixin.js
import { Component, Vue } from 'vue-property-decorator';

// You can declare a mixin as the same style as components.
@Component
export default class GAErrorEvent extends Vue {
    public errorEvent(action: string, label: any) {
        this.$ga.event('Error', 'service', action, label);
        // this.$ga.event({
        //     eventCategory: 'category',
        //     eventAction: 'action',
        //     eventLabel: 'click signin button',
        //     eventValue: 'email',
        // });

        // hitType: 'event',
        // eventCategory: 'Videos',
        // eventAction: 'play',
        // eventLabel: 'Fall Campaign'
    }
}
